import { useSearchParams } from 'react-router';
import type { SettingsTab } from '../types';

/** The selected tab, kept in `?tab=` so a tab can be linked to and survives a reload. */
export function useTabParam<T extends string>(tabs: readonly SettingsTab<T>[], fallback: T): [T, (next: T) => void] {
	const [searchParams, setSearchParams] = useSearchParams();
	const raw = searchParams.get('tab');
	const tab = tabs.find((t) => t.value === raw)?.value ?? fallback;
	const setTab = (next: T) => {
		const params = new URLSearchParams(searchParams);
		params.set('tab', next);
		setSearchParams(params, { replace: true });
	};
	return [tab, setTab];
}
